module.exports = __webpack_public_path__ + "static/media/diners.ffeb3bce.svg";